
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CalendarListView.html?raw';
import on from 'dojo/on';
import dojoQuery from 'dojo/query';

import "../WebCalendarTypes"
import { SyncFusionCalendarTypes } from "../../SyncFusionCalendar/SyncFusionCalendar/SyncFusionCalendarTypes";
import { ColorHelpers, DateHelpers, FeatureHelpers } from "../../../../more/Helpers";
import { WebcalendarTypes } from "../WebCalendarTypes";
import WebcalendarDateInfo from '../../../../WidgetCollection/WebCalendar_TS/DateInfo';






interface CLVentry{
    node: HTMLElement;
    day: CLVday;
    start: Date;
    end?: Date;
    clvItem: CLVitem;
    splitIndex: number;
}
interface CLVmonth {
    baseDate: Date;
    endDate: Date;
    //itemData: Array<WebCalendarItemData_Default>;
    headerNode: HTMLElement;
    mainNode: HTMLElement;
    contentNode: HTMLElement;
    days: Array<CLVday>;
    dataLoaded: boolean;
    invalidated: boolean;
}

interface CLVday {
    date: Date;
    node: HTMLElement;
    headerNode: HTMLElement;
    dateInfoContainer: HTMLElement;
    contentNode: HTMLElement;
    entries: Array<CLVentry>;
    month: CLVmonth;
}

interface CLVitem {
    entries: Array<CLVentry>;
    item: WebcalendarTypes.WebCalendarItemData_Default;
}
class CalendarListView extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private _monthsRegistry: Array<CLVmonth>;
    private _itemEntries: Array<CLVitem>;

    private _groupingValues: Array<string>;

    private _viewportObserver: IntersectionObserver;

    private _scrollingContainer: HTMLElement;

    _cyText: string = "";
    private mainContainer: HTMLElement;

    private btnStepForward: HTMLElement;
    private btnStepBack: HTMLElement;

    private _earliestDateValue: number;
    private _latestDateValue: number;

    private scrollDate: Date;

    maxDisplayedMonths: number = 6;

    private _getSmallOrderValue(date: Date): number {
        /* valueOf gibt einen zu großen Integer zurück für Verwendung in CSS. daher kürzen! */
        if (!date) return -1;
        let dateInt = date.valueOf(); // Timestamp seit 1970 in Millisekunden

        let smallInt = Math.ceil(dateInt / 10000); // Millisekunden und nochmal eine Zehnerstelle kürzen, weil für gewöhnlich sowieso nicht sekundengenau nötig.

        return smallInt;
    }

    getCurrentScrollDate(): Date {
        return this.scrollDate;
    }
    getCurrentSelectedFilterIDs(subFilters?: boolean): Array<string> {
        return null; // muss von außen gesetzt werden
    }
    getEarliestDate(): Date {
        if (this._earliestDateValue) {
            return new Date(this._earliestDateValue);
        }
        return null;
    }
    getLatestDate(): Date {
        if (this._latestDateValue) {
            return new Date(this._latestDateValue);
        }
        return null;
    }
    reset() {
        if (this._viewportObserver) this._viewportObserver.disconnect();

        this.UiModder.domConstruct.empty(this.mainContainer);

        this._monthsRegistry = [];
        this._itemEntries = [];

        this._earliestDateValue = null;
        this._latestDateValue = null;
    }
    resetNodes() {
        for (let itemEntry of this._itemEntries) {
            for (let entry of itemEntry.entries) {
                this.UiModder.domConstruct.destroy(entry.node);
            }
        }
    }

    private _startViewportObserver() {

        if (this._viewportObserver) this._viewportObserver.disconnect();


        let nodes = document.getElementsByClassName("dayContainer");

        this._visibleDateCells = [];

        let observer = new IntersectionObserver(lang.hitch(this, this._viewportObserverCallback), {
            threshold: 0.2,
            root: this.domNode
        });

        this._viewportObserver = observer;

        for (let i = 0; i < nodes.length; i++) {
            let node = nodes[i];
            observer.observe(node);
        }


        // einmalig gleich aufzeichnen und emitten:
        observer.takeRecords();
        this._onScroll(null);

        //console.debug(this.id + " viewportObserver started", this.getVisibleDates(), this._visibleDateCells);
    }

    private _visibleDateCells: Array<Element>;
    private _viewportObserverCallback(entries: Array<IntersectionObserverEntry>) {
        let currentFirstVisibleElement: HTMLElement = null;

        if (this._visibleDateCells.length) currentFirstVisibleElement = this._visibleDateCells[0] as HTMLElement;

        for (let i = 0; i < entries.length; i++) {
            let entry = entries[i];

            let existingIndex = this._visibleDateCells.indexOf(entry.target);

            if (entry.isIntersecting) {
                if (existingIndex == -1) {
                    this._visibleDateCells.push(entry.target);
                }
            }
            else {
                if (existingIndex > -1) {
                    this._visibleDateCells.splice(existingIndex, 1);
                }
            }
        }


        //console.debug(this.id + "_viewportObserverCallback visibleDateCells", entries, this._visibleDateCells);


    }

    getVisibleDates(): Array<Date> {
        let dates: Array<Date> = [];
        for (let cell of this._visibleDateCells) {

            try {
                let dateValueStr = cell.getAttribute("data-date");
                let date = new Date(parseInt(dateValueStr));

                dates.push(date);

            } catch (ex) {

            }
        }

        dates.sort((a, b) => { return a.valueOf() - b.valueOf() });

        return dates;
    }

    /**
     * Die Liste mit einem oder mehreren Daten (relvante Monate) starten. Erstellt für die übergebenen Daten eine leere Registry mit Monaten und Tagen.
     * Anschließend wird zum gotoDate gescrollt, falls dieses angegeben und nach dem Erstellen verfügbar ist.
     */
    setup(initialDates: Array<Date>, gotoDate?: Date) {

        if (initialDates?.length) {

            this.reset();
            for (let date of initialDates) {
                this.createMonth(date);
            }

            if (gotoDate) {
                this.goToDate(gotoDate, false);
            }
        }
    }

    redrawEntries() {
        for (let item of this._itemEntries) {
            for (let entry of item.entries) {
                this.drawAppointmentNode(entry);
            }
        }

        this.highlightItemsByKeyword(this.currentQuicksearchTerm);
    }

    setAvailableGroupingValues(groupValues: Array<string>, skipRedraw?: boolean) {
        let compareValue = null;
        let newValue = null;
        if (this._groupingValues?.length) {
            compareValue = this._groupingValues.join("-");
        }

        if (groupValues?.length) {
            newValue = groupValues.join("-");
        }

        if (newValue == compareValue) return;

        this._groupingValues = groupValues;

        if (skipRedraw !== true) {
            this.redrawEntries();
        }
    }
    setHolidays(data: Array<WebcalendarTypes.Holiday>, targetMonthDate: Date) {

        let containerNode = this.mainContainer;
        if (targetMonthDate) {
            let compareStr = DateHelpers.dateToString(targetMonthDate, "yyyy-MM-dd");
            containerNode = this.mainContainer.querySelector(".dateInfoContainer[data-date='" + compareStr + "']") as HTMLElement;
        }

        let existingNodes = containerNode.querySelectorAll(".holiday");
        for (let i = 0; i < existingNodes.length; i++) {
            this.UiModder.domConstruct.destroy(existingNodes[i]);
        }
        if (!data) return;
        if (!this.hasFeature("webcalendar/displayHolidays")) return;

        for (let appt of data) {
            let baseDate = appt.date_start as Date;
            let targetDate = appt.date_end as Date;
            if (typeof (baseDate) == "string") baseDate = new Date(baseDate);
            if (typeof (targetDate) == "string") targetDate = new Date(targetDate);

            if (!baseDate) continue;
            if (!targetDate) targetDate = new Date(baseDate.valueOf());
            if (!targetDate) continue;

            targetDate.setHours(23, 59, 59);

            while (baseDate.valueOf() <= targetDate.valueOf()) {
                let compareStr = DateHelpers.dateToString(baseDate, "yyyy-MM-dd");
                let node = this.mainContainer.querySelector(".dateInfoContainer[data-date='" + compareStr + "']") as HTMLElement;
                if (node) {
                    let apptNode = this.UiModder.domConstruct.create("span", {
                        className: "holiday",
                        innerHTML: appt.description,
                        title: appt.description
                    }, node);

                    if (appt.color) {
                        let bgcolor = ColorHelpers.getHexColorFromProperty(appt.color, "BG");
                        let txtcolor = ColorHelpers.getHexColorFromProperty(appt.color, "TXT");
                        apptNode.style.setProperty("--bgColor", bgcolor);
                        apptNode.style.setProperty("--txtColor", txtcolor);
                    }
                }

                baseDate.setDate(baseDate.getDate() + 1);
            }
        }
    }
    updateItem(item: WebcalendarTypes.WebCalendarItemData_Default) {
        if (!item) return;
        this.addItems([item]);
    }
    setItemResponse(items: Array<WebcalendarTypes.WebCalendarItemData_Default>, targetMonth: Date, scrollToDate?: Date, suppressEmit?: boolean) {

        //console.log(this.id + " setItemResponse", targetMonth, items);

        let month = this.createMonth(targetMonth);
        month.dataLoaded = true;
        this.UiModder.domClass.remove(month.mainNode, "unloaded");

        this.addItems(items);

        if (!suppressEmit) {
            // mainproperties informieren, dass das laden und zeichnen beendet ist. dann beginnt das Laden der external-events (zb google-sync)
            this.emit("addItemsComplete", { callback: this._onCallbackAdditionalEventData, scope: this });
        }

        if (!scrollToDate) scrollToDate = this.scrollDate;

        if (scrollToDate) {
            setTimeout(lang.hitch(this, this.goToDate, scrollToDate, false), 100);
            setTimeout(lang.hitch(this, this.highlightItemsByKeyword, this.currentQuicksearchTerm), 100);
        }
    }

    /**
     * Fügt Termine in den Tagesraster ein bzw. aktualisiert bestehende und zeichnet sie neu.
     * Es werden nur bestehende Monate und Tage zum Einfügen benutzt. Termine außerhalb der existierenden Monatsregistry werden nicht gezeichnet.
     * @param items Array von Kalenderitems (Termindaten, die auch merhtägig sein können)
     */
    private addItems(items: Array<WebcalendarTypes.WebCalendarItemData_Default>) {
        for (let item of items) {
            let registryItem: CLVitem = this.getItemById(item.id);
            if (registryItem != null) {
                for (let entry of registryItem.entries) {
                    if (entry.node) {
                        this.UiModder.domConstruct.destroy(entry.node);
                    }
                }

                registryItem.entries = [];
                registryItem.item = item;
            }
            if (registryItem == null) {
                registryItem = {
                    entries: [],
                    item: item
                };

                this._itemEntries.push(registryItem);
            }

            let startClone = new Date(item.startTime);
            let itemEnd = new Date(item.endTime);
            let index = 0;
            while (startClone.valueOf() <= itemEnd.valueOf()) {

                let day = this.getDayEntryByDate(startClone, false);
                let isSplit = this.dateToString(startClone, "ddMMyyyy") != this.dateToString(itemEnd, "ddMMyyyy");

                let virtualEnd = new Date(itemEnd.valueOf());

                if (isSplit) {
                    virtualEnd = new Date(startClone.valueOf());
                    virtualEnd.setHours(23, 59, 59);
                }

                let entry: CLVentry = {
                    clvItem: registryItem,
                    day: day,
                    node: null,
                    splitIndex: index,
                    start: new Date(startClone.valueOf()),
                    end: virtualEnd
                };
                registryItem.entries.push(entry);

                if (day) {
                    this.UiModder.domClass.remove(day.node, "empty");
                    if (day.entries.length == 0) this.UiModder.domConstruct.empty(day.contentNode);
                    day.entries.push(entry);
                }


                startClone.setHours(0, 0, 0, 0);
                startClone.setDate(startClone.getDate() + 1);
                index++;
            }

            for (let entry of registryItem.entries) {
                let appointmentNode = this.drawAppointmentNode(entry);

            }

        }
    }

    /**
     * bekommt von den MainProperties external Events welche zusätzlich und nach dem ladend er eigentlichen Termine im Kalender angezeigt werden
     */
    private _onCallbackAdditionalEventData(additionalEvents: Array<SyncFusionCalendarTypes.Syncfusion_EventItem<WebcalendarTypes.WebCalendarItemData_Default>>) {
        //console.log("ListView: das kam als external events:", additionalEvents);

        let existingItems = [];

        for (let i = 0; i < additionalEvents.length; i++) {

            // die Events kommen im "Syncfusion-Format". Der Listview braucht aber nur das Object darin
            let eventItem = additionalEvents[i].Object;
            existingItems.push(eventItem);
        }

        this.addItems(existingItems); // hinzufügen zeichnet auch gleich
    }

    private _applyItemColoration(entry: CLVentry) {
        let calendarItem = entry.clvItem.item;
        let itemNode = entry.node;

        if ((calendarItem.bOverrideColoration == true || !calendarItem.coloration.length) && (calendarItem.Default_BackColor || calendarItem.Default_TextColor)) {
            //itemNode.style.backgroundColor = this.setOpacityHex(calendarItem.Default_BackColor, 'CC'); // 0.9 = E6 ; 0.8 = CC ; 0.7 = B3
            this._applyDefaultcolors(entry);
        } else {
            let bMatchComplete = false;
            let classlist = [calendarItem.Classname];
            if (calendarItem.BaseClasses?.length) {
                for (let classname of calendarItem.BaseClasses) {
                    classlist.push(classname);
                }
            }

            // Matching versuchen! beginnend mit der eigentlichen Klasse, dann weiter mit den Basisklassen...
            for (let classname of classlist) {
                for (let i = 0; i < calendarItem.coloration.length; i += 1) {
                    let color = calendarItem.coloration[i];

                    let colorEntry = this.getColorEntryByClass(classname);

                    if (colorEntry && color && color.ID === colorEntry.colorId) {
                        bMatchComplete = true;
                        //itemNode.style.backgroundColor = this.setOpacityHex(color.BackColor, 'CC'); // 0.9 = E6 ; 0.8 = CC ; 0.7 = B3
                        itemNode.style.setProperty("--itemColorBG", "#" + color.BackColor); // 0.9 = E6 ; 0.8 = CC ; 0.7 = B3

                        if (color.TextColor) {
                            //itemNode.style.color = "#" + color.TextColor;
                            itemNode.style.setProperty("--itemColorTXT", "#" + color.TextColor);
                        } else {
                            //itemNode.style.color = this.isDarkColor(color.BackColor) ? "var(--bright)" : "var(--dark)";
                            itemNode.style.setProperty("--itemColorTXT", this.isDarkColor(color.BackColor) ? "var(--bright)" : "var(--dark)");

                        }
                        break;
                    }
                }

                if (bMatchComplete == true) {
                    this.UiModder.domClass.remove(itemNode, "missingColoration");
                    break;
                } else {
                    this._applyDefaultcolors(entry);
                }
            }
            if (bMatchComplete != true) {
                console.warn("event coloring failed", calendarItem, this.itemColorationValues);

                itemNode.style.color = "var(--missingItemColorTxt, white)";
                itemNode.style.backgroundColor = "var(--missingItemColorBg, #888)";
                this.UiModder.domClass.add(itemNode, "missingColoration");

            }
        }


    }

    private _applyDefaultcolors(entry: CLVentry) {
        if (!entry) return;

        let calendarItem = entry.clvItem.item;
        let itemNode = entry.node;

        if (!calendarItem || !itemNode) return;

        if (!calendarItem.Default_BackColor && !calendarItem.Default_TextColor) {

        } else {
            this.UiModder.domClass.remove(itemNode, "missingColoration");
            itemNode.style.setProperty("--itemColorBG", "#" + calendarItem.Default_BackColor); // 0.9 = E6 ; 0.8 = CC ; 0.7 = B3
            if (calendarItem.Default_TextColor) {
                //itemNode.style.color = "#" + calendarItem.Default_TextColor;
                itemNode.style.setProperty("--itemColorTXT", "#" + calendarItem.Default_TextColor);
            } else {
                //itemNode.style.color = this.isDarkColor(calendarItem.Default_BackColor) ? "var(--bright)" : "var(--dark)";
                itemNode.style.setProperty("--itemColorTXT", this.isDarkColor(calendarItem.Default_BackColor) ? "var(--bright)" : "var(--dark)");
            }
        }
    }

    private itemColorationValues: Array<WebcalendarTypes.ColorValue>;

    addColorToRegistry(id: string, classname: string): void {
        //console.debug("setScheduleEventColoration", classname, this.itemColorationValues);

        let colorReg = this.getColorEntryByClass(classname);
        if (colorReg) {
            colorReg.colorId = id;

        } else {
            this.itemColorationValues.push({
                classname: classname,
                colorId: id
            });
        }

        this.redrawEntries();
    }
    private getColorValueIndexByClass(classname: string): number {
        let i = -1;
        for (let entry of this.itemColorationValues) {
            i++;
            if (entry.classname == classname) return i;
        }

        return -1;
    }
    private getColorEntryByClass(classname: string): WebcalendarTypes.ColorValue {
        let i = this.getColorValueIndexByClass(classname);
        if (i == -1) return null;

        return this.itemColorationValues[i];

    }
    private drawAppointmentNode(entry: CLVentry) {
        if (!entry || !entry.clvItem?.item) return;

        if (entry.node) this.UiModder.domConstruct.destroy(entry.node);

        if (entry.day) {
            let node = this.UiModder.domConstruct.create("div", {
                className: "appointment",
                style: {
                    "order": this._getSmallOrderValue(entry.start)
                }
            }, entry.day.contentNode);

            node.setAttribute("data-entity-classname", entry.clvItem.item.Classname);
            node.setAttribute("data-entity-id", entry.clvItem.item.id);

            let horizontalRow = this.UiModder.domConstruct.create("div", {
                className: "row",
                style: {

                }
            }, node);

            let colLeft = this.UiModder.domConstruct.create("div", {
                className: "col left",
                style: {

                }
            }, horizontalRow);

            let colRight = this.UiModder.domConstruct.create("div", {
                className: "col right",
                style: {

                }
            }, horizontalRow);


            entry.node = node;


            on(node, "click", lang.hitch(this, this._onClickAppointment, entry));
            on(node, "mouseenter", lang.hitch(this, this._onMouseEnterAppointment, entry));
            on(node, "mouseleave", lang.hitch(this, this._onMouseLeaveAppointment, entry));

            this._applyItemColoration(entry);

            let startLabel = this.UiModder.domConstruct.create("span", {
                innerHTML: this.dateTimeToString(entry.start, "dd.MM.yyyy HH:mm"),
                className: "startTime"
            }, colLeft);

            if (entry.end) {
                let endLabel = this.UiModder.domConstruct.create("span", {
                    innerHTML: this.dateTimeToString(entry.end, " - HH:mm"),
                    className: "endTime"
                }, colLeft);
            }

            if (entry.clvItem.entries.length > 1) {
                let splitLabel = this.UiModder.domConstruct.create("span", {
                    innerHTML: this.stringFormat("{0}/{1}", entry.splitIndex + 1, entry.clvItem.entries.length),
                    className: "splitIndex"
                }, colLeft);
            }

            let heading = this.UiModder.domConstruct.create("span", {
                innerHTML: entry.clvItem.item.columnview_head_text,
                class: "header"
            }, colLeft);

            if (entry.clvItem.item.columnview_body_text) {
                let body = this.UiModder.domConstruct.create("span", {
                    innerHTML: entry.clvItem.item.columnview_body_text,
                    className: "body"
                }, colLeft);
            }

            if (entry.clvItem.item.groupValue) {
                if (this._groupingValues?.length && this._groupingValues.indexOf(entry.clvItem.item.groupValue) != -1) {
                    this.UiModder.domConstruct.create("span", {
                        innerHTML: entry.clvItem.item.groupValue,
                        className: "groupValue"
                    }, colRight);
                }
            }

        }

        if (entry.clvItem.entries.length > 1 && entry.node) {
            this.UiModder.domClass.toggle(entry.node, "hasPartsBefore", entry.splitIndex > 0);
            this.UiModder.domClass.toggle(entry.node, "hasPartsAfter", entry.splitIndex < entry.clvItem.entries.length - 1);

        }

        //let endLabel = this.UiModder.domConstruct.create("span", {
        //    innerHTML: this.dateTimeToString(entry.start, "HH:mm"),
        //    className: "startTime"
        //}, node);

    }

    private getItemById(id: string): CLVitem {
        for (let registryItem of this._itemEntries) {
            if (registryItem.item.id == id) {
                return registryItem;
            }
        }

        return null;
    }
    private _emitDataloadingHandle: number;

    private _destroyMonth(month: CLVmonth) {
        this.UiModder.domConstruct.destroy(month.mainNode);
        let splitItems: Array<WebcalendarTypes.WebCalendarItemData_Default> = [];
        let itemIds = [];

        // items der Monate nochmal versuchen neu zu zeichnen, weil ggf. mehrtägige Termine ihre Registry und nodes updaten müssen:
        for (let day of month.days) {

            for (let entry of day.entries) {
                if (itemIds.indexOf(entry.clvItem.item.id) == -1) {
                    itemIds.push(entry.clvItem.item.id);

                    if (entry.clvItem.entries.length > 1) {
                        splitItems.push(entry.clvItem.item);
                    }
                }
            }
        }

        let keepMonths = [];

        for (let existingMonth of this._monthsRegistry) {
            if (existingMonth.baseDate.valueOf() != month.baseDate.valueOf()) {
                keepMonths.push(existingMonth);


            }
        }

        this._monthsRegistry = keepMonths;
        //this._monthsRegistry.sort((a, b) => { return a.baseDate.valueOf() - b.baseDate.valueOf() });

        if (this._monthsRegistry.length > 0) {

            this._earliestDateValue = this._monthsRegistry[0].baseDate.valueOf();
            this._latestDateValue = this._monthsRegistry[this._monthsRegistry.length - 1].endDate.valueOf();
        } else {
            this._earliestDateValue = new Date().valueOf();
            this._latestDateValue = -1;
        }
        this._setStepperLabels();

        this._monthsRegistry = keepMonths;

        this.addItems(splitItems);

        this._startViewportObserver();
    }
    showTimeIndicator(bShow: boolean = true) {
        this.domNode.setAttribute("data-timeindicator", bShow ? "true" : "false");
        this._drawCurrentTimeIndicator();
    }

    showEndTime(bShow: boolean = true) {
        this.domNode.setAttribute("data-display-endtime", bShow ? "true" : "false");
    }
    showStartTime(bShow: boolean = true) {
        this.domNode.setAttribute("data-display-starttime", bShow ? "true" : "false");
    }
    showGroups(bShow: boolean = true, bStrict: boolean = false) {
        this.domNode.setAttribute("data-display-groups", bShow ? "true" : "false");
        this.domNode.setAttribute("data-limit-to-groups", bShow == true && this._groupingValues?.length > 0 && bStrict === true ? "true" : "false");
    }
    public createMonth(date: Date): CLVmonth {
        if (date) {
            return this.createMonthEntry(date.valueOf());
        }
        return null;
    }
    private _timeIndicator: HTMLElement;
    private _drawCurrentTimeIndicator() {
        if (this._timeIndicator) {
            try {
                this.UiModder.domConstruct.destroy(this._timeIndicator);
            } catch (ex) {

            }
        }
        let now = new Date();

        let day = this.getDayEntryByDate(now, false);
        if (!day) return;

        let node = this.UiModder.domConstruct.create("span", {
            className: "timeIndicator flex_row_center",
            style: {
                "order": this._getSmallOrderValue(now)
            }
        }, day.contentNode);

        node.setAttribute("data-label", this.dateToString(now, "HH:mm"));

        this._timeIndicator = node;
    }
    private createMonthEntry(dateValue: number, resetIfExisting?: boolean): CLVmonth {
        if (!dateValue) return null;

        let monthEntry = this.getMonthByDate(dateValue);


        if (monthEntry == null) {

            let today = new Date();

            // Kopie machen und auf 1. des Monats 0:00:00 setzen
            let baseDate = new Date(dateValue);
            baseDate.setDate(1);
            baseDate.setHours(0, 0, 0, 0);

            let baseDateValue = baseDate.valueOf();

            let createdAt: "top" | "bottom" = "bottom"; // wo ist der neue Monat erzeugt worden? unten dran oder oben drauf?

            // Ende des Monats ermitteln
            let endOfMonth = new Date(baseDateValue);
            endOfMonth.setMonth(baseDate.getMonth() + 1);
            endOfMonth.setDate(endOfMonth.getDate() - 1);
            endOfMonth.setHours(23, 59, 59);

            //console.debug(this.id + " createMonthEntry", baseDate, endOfMonth, new Date(this._earliestDateValue), new Date(this._latestDateValue));

            if (!this._earliestDateValue) {
                this._earliestDateValue = baseDateValue;
            } else if (this._earliestDateValue > baseDateValue) {
                this._earliestDateValue = baseDateValue;
                createdAt = "top";
            }

            if (!this._latestDateValue) {
                this._latestDateValue = endOfMonth.valueOf();
            } else if (this._latestDateValue < endOfMonth.valueOf()) {
                this._latestDateValue = endOfMonth.valueOf();
                createdAt = "bottom";
            }

            if (!this.scrollDate) this.scrollDate = new Date(this._earliestDateValue);

            this._setStepperLabels();

            let node = this.UiModder.domConstruct.create("div", {
                className: "monthContainer unloaded",
                id: this.dateToString(baseDate, "MM"),
                style: {
                    "order": parseInt(this.dateToString(baseDate, "yyyyMM"))
                }
            }, this.mainContainer);

            node.setAttribute("data-month", node.id);
            node.setAttribute("data-year", this.dateToString(baseDate, "yyyy"));

            let header = this.UiModder.domConstruct.create("div", {
                className: "monthHeaderContainer",
                style: {
                    "order": -1
                },
                innerHTML: this.dateToString(baseDate, "MMMM yyyy")
            }, node);


            header.setAttribute("data-month-label", header.innerHTML);


            let contentNode = this.UiModder.domConstruct.create("div", {
                className: "monthContent"
            }, node);

            monthEntry = {
                baseDate: baseDate,
                endDate: endOfMonth,
                contentNode: contentNode,
                mainNode: node,
                days: [],
                headerNode: header,
                dataLoaded: false,
                invalidated: false
            };

            this._monthsRegistry.push(monthEntry);

            let loopDate = new Date(baseDate.valueOf());
            while (loopDate.getMonth() == baseDate.getMonth()) {

                let dayDate = new Date(loopDate.valueOf());

                let dayNode = this.UiModder.domConstruct.create("div", {
                    className: "dayContainer empty",
                    style: {
                        "order": this._getSmallOrderValue(dayDate)
                    }
                }, monthEntry.contentNode);


                let dayContent = this.UiModder.domConstruct.create("div", {
                    className: "dayContent",

                }, dayNode);

                let dayHeader = this.UiModder.domConstruct.create("div", {
                    className: "dayHeader",
                    innerHTML: this.dateToString(dayDate, "EEEE dd.MM.yyyy")
                }, dayNode, "first");

                dayNode.setAttribute("data-date", dayDate.valueOf().toString());


                let dateInfoNode = this._createDateInfoContainer(dayHeader, dayDate);

                if (dayDate.getDay() == 0 || dayDate.getDay() == 6) {
                    this.UiModder.domClass.add(dayNode, "weekend");
                }

                let day: CLVday = {
                    date: dayDate,
                    entries: [],
                    node: dayNode,
                    contentNode: dayContent,
                    headerNode: dayHeader,
                    dateInfoContainer: dateInfoNode,
                    month: monthEntry
                }

                on(dayNode, "click", lang.hitch(this, this._onClickDay, day));

                monthEntry.days.push(day);

                if (this.dateToString(dayDate, "yyyy-MM-dd") == this.dateToString(today, "yyyy-MM-dd")) {
                    this.UiModder.domClass.add(dayNode, "today");
                    this._drawCurrentTimeIndicator();
                }

                loopDate.setDate(loopDate.getDate() + 1);
            }

            this._monthsRegistry.sort((a, b) => { return a.baseDate.valueOf() - b.baseDate.valueOf() });

            if (this._monthsRegistry.length > this.maxDisplayedMonths) {
                // wurde oben erzeugt, also unten abknipsen:
                if (createdAt == "top") {
                    this._destroyMonth(this._monthsRegistry[this._monthsRegistry.length - 1]);
                }

                // wurde unten dran erzeugt, also oben wegknipsen:
                else if (createdAt == "bottom") {
                    this._destroyMonth(this._monthsRegistry[0]);
                }

            }


            //console.debug(this.id + " monthRegistry modified", this._monthsRegistry, new Date(this._earliestDateValue), new Date(this._latestDateValue));


            this._startViewportObserver();

            if (monthEntry.dataLoaded != true) {
                if (this._emitDataloadingHandle) clearTimeout(this._emitDataloadingHandle);

                this._emitDataloadingHandle = setTimeout(lang.hitch(this, "emit", "unloadedMonths"), 100);
            }
        }

        else if (monthEntry.invalidated === true) {
            monthEntry.invalidated = false;

            for (let day of monthEntry.days) {
                this.UiModder.domConstruct.empty(day.contentNode);
                this.UiModder.domClass.add(day.contentNode, "empty");
            }
        }
        return monthEntry;
    }

    private getDayEntryByDate(date: Date, createEntry?: boolean): CLVday {
        let compareDate = new Date(date.valueOf());
        compareDate.setHours(0, 0, 0, 0);

        let baseDate = new Date(date.valueOf());
        baseDate.setDate(1);
        baseDate.setHours(0, 0, 0, 0);

        for (let month of this._monthsRegistry) {
            if (month.baseDate.valueOf() == baseDate.valueOf()) {
                for (let day of month.days) {
                    if (day.date.valueOf() == compareDate.valueOf()) {
                        return day;
                    }
                }
                break;
            }
        }

        if (createEntry === true) {
            this.createMonthEntry(date.valueOf());

            return this.getDayEntryByDate(date, false);
        }

        return null;
    }

    private getMonthByDate(dateValue: number, createEntry?: boolean) {

        // Kopie machen und auf 1. des Monats 0:00:00 setzen für den Vergleich
        let baseDate = new Date(dateValue);
        baseDate.setDate(1);
        baseDate.setHours(0, 0, 0, 0);

        for (let month of this._monthsRegistry) {
            if (month.baseDate.valueOf() == baseDate.valueOf()) {
                return month;
            }
        }

        if (createEntry == true) {
            return this.createMonthEntry(dateValue);
        }

        return null;
    }

    private _createDateInfoContainer(targetNode: HTMLElement, date: Date): HTMLElement {


        if (!targetNode) return;

        try {
            let dateKey = this.dateToString(date, "yyyy-MM-dd");

            let infoContainer = this.UiModder.domConstruct.create("div", {
                "className": "dateInfoContainer"
            }, targetNode, "last");

            infoContainer.setAttribute("data-date", dateKey);

            if (FeatureHelpers.hasFeature("Webcalendar/EnableDateInfoPopup")) {

                this.UiModder.domClass.add(targetNode, "clickableDate");

                on(targetNode, "click", lang.hitch(this, this._onClick_DateInfo, date));
            }


            //console.debug("_createDateInfoContainer", targetNode, infoContainer);

            return infoContainer;
        } catch (ex) {
            console.warn(this.id + " _createDateInfoContainer failed", ex);
        }
        return null;
    }
    private _currentDateInfo: { dateStr: string, dateInfoWidget: MdsLax<InstanceType<typeof WebcalendarDateInfo>> } = { dateInfoWidget: null, dateStr: "xx" };

    private _onClick_DateInfo(dayDate: Date, evt: MouseEvent) {
        if (evt?.stopPropagation) evt.stopPropagation();

        let dateStr = DateHelpers.dateToLocalISOString(dayDate);

        if (this._currentDateInfo.dateStr == dateStr) {
            if (this._currentDateInfo.dateInfoWidget && !this._currentDateInfo.dateInfoWidget._destroyed) {
                return;
            }
        }

        let clv = this.getDayEntryByDate(dayDate);

        let infoDlg = new WebcalendarDateInfo();
        infoDlg.setup({
            position: "absolute",
            node: clv.dateInfoContainer,
            targetDate: dayDate,
            evt: evt,
            activeFilterIDs: this.getCurrentSelectedFilterIDs(),
            activeSubfilterIDs: this.getCurrentSelectedFilterIDs(true)
        });

        this._currentDateInfo = { dateStr: dateStr, dateInfoWidget: infoDlg };
    }



    private _onClickDay(day: CLVday, evt: MouseEvent) {
        let endDate = new Date(day.date.valueOf());
        endDate.setHours(23, 59, 59);

        let data: WebcalendarTypes.CellClickData_Simple = {
            endTime: endDate,
            startTime: day.date,
            isAllDay: true,
            evt: evt,
            node: day.node
        }

        this.emit("dayClick", data);
    }
    private _onClickAppointment(appointment: CLVentry, evt: MouseEvent) {
        if (appointment.clvItem.item.Classname == "__external__") {
            return; // kein click für external events
        }
        this.emit("itemClick", appointment.clvItem.item, evt as any);
    }
    private _onMouseEnterAppointment(appointment: CLVentry, evt: MouseEvent) {
        for (let entry of appointment.clvItem.entries) {
            if (entry.node) {
                this.UiModder.domClass.add(entry.node, "hover");
            }
        }
    }
    private _onMouseLeaveAppointment(appointment: CLVentry, evt: MouseEvent) {
        for (let entry of appointment.clvItem.entries) {
            if (entry.node) {
                this.UiModder.domClass.remove(entry.node, "hover");
            }
        }
    }

    private _onClick_StepBack(evt: MouseEvent) {
        // merken wo der früheste Monat derzeit gescrollt ist:
        let month = this.getMonthByDate(this._earliestDateValue);
        if (!month) {
            this.step(-1, "month");

        } else {
            let rect = month.headerNode.getBoundingClientRect();
            let scrollPosition = rect.top;
            rect = month.headerNode.getBoundingClientRect();

            this.step(-1, "month");

            // nach dem Hinzufügen oben rutscht der Rest nach unten. Neue Position auslesen:
            rect = month.headerNode.getBoundingClientRect();
            let newScrollPosition = rect.top;

            // um die Differenz scrollen:
            let diff = newScrollPosition - scrollPosition;
            this._scrollingContainer.scrollBy(0, diff);
            //setTimeout(lang.hitch(this, function (diff) { this._scrollingContainer.scrollBy(0, diff); }, newScrollPosition - scrollPosition), 100);

        }


    }
    private _onClick_StepForward(evt: MouseEvent) {
        this.step(1, "month");
    }

    goToDate(targetDate: Date, resetIfNotInRange: boolean = true) {
        if (!targetDate) return;

        let existing = this.getDayEntryByDate(targetDate);
        if (existing && existing.node) {
            existing.node.scrollIntoView({ block: "center", behavior: "smooth" });
        } else {
            // ist das Goto nur einen Monat entfernt?
            let currentEarlistDate = new Date(this._earliestDateValue);
            let currentLatestDate = new Date(this._latestDateValue);

            let currentNextDate = new Date(this._latestDateValue);
            currentNextDate.setDate(1);
            currentNextDate.setMonth(currentNextDate.getMonth() + 1);

            let currentPreviousDate = new Date(this._earliestDateValue);
            currentPreviousDate.setMonth(currentPreviousDate.getMonth() - 1);

            let compareStr = this.dateToString(targetDate, "yyyy-MM");
            let compareStrNex = this.dateToString(currentNextDate, "yyyy-MM");
            let compareStrPrev = this.dateToString(currentPreviousDate, "yyyy-MM");

            if (compareStr == compareStrNex) {
                this.step(1, "month");
                setTimeout(lang.hitch(this, this.goToDate, targetDate), 100);
                return;
            } else if (compareStr == compareStrPrev) {
                this.step(-1, "month");
                setTimeout(lang.hitch(this, this.goToDate, targetDate), 100);
                return;
            }

            // setup neu?
            if (resetIfNotInRange !== false) {
                this.reset();
                this.setup([targetDate]);

                setTimeout(lang.hitch(this, this.goToDate, targetDate), 100);
            }
        }
    }

    step(amount: number | "min" | "max" = 1, mode?: "month" | "day") {

        if (amount == 0 || !amount) {
            return;
        }

        let baseDate = new Date();
        baseDate.setDate(1);
        baseDate.setHours(0, 0, 0, 0);

        let targetDate = new Date();
        let direction = 1;


        let nodes = dojoQuery(".dayContainer", this.mainContainer);

        //console.debug(this.id + " step:", amount, mode);

        if (amount == "min") {
            this.goToDate(new Date(this._earliestDateValue));
            return;
        }
        if (amount == "max") {
            this.goToDate(new Date(this._latestDateValue));
            return;
        }

        else if (typeof (amount) == "number" && mode == "day") {

            if (amount < 0) direction = -1;

            let visibleDates = this.getVisibleDates();

            if (visibleDates.length > 0) {

                if (amount > 0) {
                    targetDate = new Date(visibleDates[visibleDates.length - 1].valueOf());
                }
                else {
                    targetDate = new Date(visibleDates[0].valueOf());
                }
            }
            else {
                targetDate = this.scrollDate;
            }

            if (!targetDate) return;

            targetDate.setHours(0, 0, 0, 0);

            targetDate.setDate(targetDate.getDate() + amount);

            if (targetDate.valueOf() < this._earliestDateValue) {
                // nicht im geladenen Bereich, wir müssen zurücksteppen...
                this.step(direction, "month");

                // RACE CONDITION! viewport-observer mit visibleDates manchmal noch nicht fertig
                setTimeout(lang.hitch(this, this.goToDate, targetDate), 100);
                return;
            } else if (targetDate.valueOf() > this._latestDateValue) {
                this.step(direction, "month");

                // RACE CONDITION! viewport-observer mit visibleDates manchmal noch nicht fertig
                setTimeout(lang.hitch(this, this.goToDate, targetDate), 100);
                return;
            }

            let targetMonth = this.getMonthByDate(targetDate.valueOf());

            if (targetMonth) {
                for (let day of targetMonth.days) {
                    if (day.date.valueOf() == targetDate.valueOf()) {
                        day.node.scrollIntoView({ block: "center", behavior: "smooth" });
                        //setTimeout(lang.hitch(this, this._onScroll, null), 10);
                        break;
                    }
                }
            }
        }

        else if (typeof (amount) == "number" && mode == "month") {



            // aus dem step-amount errechnen, wohin wir mit dem Datum wollen


            if (this._monthsRegistry.length) {
                // falls wir in die Zukunft steppen: letzter Monatseintrag ist Basis
                if (amount >= 1) {
                    baseDate = this._monthsRegistry[this._monthsRegistry.length - 1].baseDate;
                } else if (amount < 0) {
                    direction = -1;

                    // in die Vergangenheit steppen: erster Monatseintrag ist Basis
                    baseDate = this._monthsRegistry[0].baseDate;
                }

                baseDate = new Date(baseDate.valueOf()); // Kopie machen, weils unten durchiteriert
                targetDate = new Date(baseDate.valueOf()); // KOpie, weil wir noch amount dazuzählen
            } else {
                // keine Einträge in Registry: mit aktuellem Monat starten
                targetDate.setHours(0, 0, 0, 0);
                targetDate.setDate(1);
            }

            // amount dazuzählen
            targetDate.setMonth(targetDate.getMonth() + amount);

            //console.log(this.id + " step: " + amount, mode, baseDate, "->", targetDate)


            // jetzt haben wir: base-Date (aktuelle Registry-Grenzen oder heute) und target-Date (Schritt(e) vor oder zurück)
            let counter = 0;
            while (baseDate.getMonth() != targetDate.getMonth()) {
                baseDate.setMonth(baseDate.getMonth() + direction);

                this.createMonth(baseDate);

                counter++;

                if (counter == 999) {
                    // da läuft was falsch. abbruch
                    break;
                }
            }
        }
    }

    private _setStepperLabels() {
        let labelPrevious = "";
        let labelNext = "";

        try {
            let previousMonth = new Date(this._earliestDateValue);
            previousMonth.setMonth(previousMonth.getMonth() - 1);
            labelPrevious = this.dateToString(previousMonth, "MMMM yyyy");
        } catch (ex) {

        }
        try {
            let nextMonth = new Date(this._latestDateValue);
            nextMonth.setDate(nextMonth.getDate() + 1);
            labelNext = this.dateToString(nextMonth, "MMMM yyyy");
        } catch (ex) {

        }
        this.btnStepBack.firstElementChild.innerHTML = labelPrevious;
        this.btnStepForward.firstElementChild.innerHTML = labelNext;
    }

    getItemNodes(withNodesOnly?: boolean): Array<CLVentry> {
        let result: Array<CLVentry> = [];
        for (let item of this._itemEntries) {
            item.entries.forEach((entry) => { if (withNodesOnly !== true || entry.node) result.push(entry); });
        }
        return result;
    }

    /**
     * Stellt alle geladenen Monate auf ungültig, sodass diese als "nicht geladen" gelten. Alle geladenen Daten werden zurückgesetzt.
     * Bei der nächsten SetItemResponse werden bereits gezeichnete Einträge entfernt.
     *
     * @param emitUnloadedEvent Wenn true, wird das Listviewwidget ein emit ausführen, das ggf. von anderer Stelle zum Neuladen der Monate interpretiert wird.
     */
    invalidateData(emitUnloadedEvent?: boolean) {
        for (let month of this._monthsRegistry) {
            if (month.invalidated != true) {
                month.dataLoaded = false;
                month.invalidated = true;
                for (let day of month.days) {
                    day.entries = [];
                }
            }
            
            if (month.mainNode) {
                this.UiModder.domClass.add(month.mainNode, "unloaded");
            }
        }

        this._itemEntries = [];


        if (emitUnloadedEvent === true) {
            if (this._emitDataloadingHandle) clearTimeout(this._emitDataloadingHandle);

            this._emitDataloadingHandle = setTimeout(lang.hitch(this, "emit", "unloadedMonths"), 100);
        }
    }

    /**
     * Gibt das Basisdatum (1. des Monats 0:00:00:000 Uhr) eines jeden ungeladenen Monats zurück.
     */
    getUnloadedMonths(forceReload: boolean = false): Array<Date> {
        let result: Array<Date> = [];

        for (let month of this._monthsRegistry) {
            if (month.dataLoaded != true || forceReload) result.push(new Date(month.baseDate.valueOf()));
        }

        result.sort((a, b) => { return a.valueOf() - b.valueOf(); });

        return result;
    }

    private currentQuicksearchTerm: string;

    highlightItemsByKeyword(searchString: string) {
        if (!searchString && !this.currentQuicksearchTerm) return;

        let items = this.getItemNodes(true);

        if (searchString != this.currentQuicksearchTerm) {
            setTimeout(lang.hitch(this, this.emit, "search", searchString), 10);
            this.currentQuicksearchTerm = searchString;
        }

        for (let item of items) {
            let node = item.node;
            this.UiModder.domClass.remove(node, "searchHighlight");
        }


        if (searchString) {
            this.UiModder.domClass.add(this.mainContainer, "quicksearchActive");

            searchString = searchString.toLowerCase();

            let highlightedItems = items.filter(function (item) {
                if (item.node) {
                    let str = item.clvItem.item.barview_text + " " + item.clvItem.item.columnview_body_text + " " + item.clvItem.item.columnview_head_text;
                    if (str) {
                        str = str.toLowerCase();
                        if (str.indexOf(searchString) != -1) {
                            return true;
                        }
                    }
                }
                return false;
            });

            this.emit("searchresult", highlightedItems.length);

            for (let item of highlightedItems) {
                this.UiModder.domClass.add(item.node, "searchHighlight");
            }

            if (highlightedItems.length) {
                highlightedItems[0].node.scrollIntoView({ block: "center" });

            }
            else {

            }


        } else {
            this.UiModder.domClass.remove(this.mainContainer, "quicksearchActive");
        }
    }

    private _scrollEmitHandle: number = null;
    private _scrollHandlerTimeout: number = null;
    private _onScroll(evt: Event) {
        if (this._scrollHandlerTimeout) {
            clearTimeout(this._scrollHandlerTimeout);
        }

        this._scrollHandlerTimeout = setTimeout(lang.hitch(this, this._scrollHandler, 100));
    }
    private _scrollHandler(evt: Event) {

        let dates = this.getVisibleDates();
        //console.debug(this.id + " visible dates", dates);
        if (dates.length) {
            let earliestStr = this.dateToString(new Date(this._earliestDateValue), "dd.MM.yyyy");
            let latestStr = this.dateToString(new Date(this._latestDateValue), "dd.MM.yyyy");

            // falls der erste Tag eines Monats im Sichtbereich ist, diesen ein bisschen "stickier" machen:
            let firstDayInMonthIndex = -1;
            for (let i = 0; i < 10; i++) {
                if (i == dates.length) break;
                if (dates[i].getDate() == 1) {
                    firstDayInMonthIndex = i;
                    break;
                }
            }
            let lastVisibleStr = this.dateToString(dates[dates.length - 1], "dd.MM.yyyy");

            if (latestStr == lastVisibleStr) {
                this.scrollDate = dates[dates.length - 1];
            } else if (firstDayInMonthIndex != -1) {
                this.scrollDate = dates[firstDayInMonthIndex];
            } else {
                if (dates.length > 1) {
                    this.scrollDate = dates[Math.ceil(dates.length / 2)];
                } else {
                    this.scrollDate = dates[0];
                }
            }
        }

        if (this._scrollEmitHandle) {
            clearTimeout(this._scrollEmitHandle);
        }

        this._scrollEmitHandle = setTimeout(lang.hitch(this, "emit", "scroll"), 50);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///
        if (this._cyText) {
            this.domNode.setAttribute("data-cy", "calendarListView:" + this._cyText);
        }
        this.itemColorationValues = [];
        this.reset();

        on(this._scrollingContainer, "scroll", lang.hitch(this, this._onScroll));

        setInterval(lang.hitch(this, this._drawCurrentTimeIndicator), 2 * 60 * 1000); // alle x Minuten mal neu Indikator neu zeichnen

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }



}

export default mdsWidget(CalendarListView);
